import(/* webpackMode: "eager", webpackExports: ["CatalogPage"] */ "/app/src/screens/catalog/ui/CatalogPage.tsx");
